
import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import CommonReactTable from '../CommonUtils/CommonReactTable';
import { config } from '../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { successAlert2 } from '../CommonUtils/SweetAlerts';
import { FaCheckCircle, } from "react-icons/fa";

export default function UniversitySubjectFacReport() {

    const userId = sessionStorage.getItem("user_id");

    const ROLEID = sessionStorage.getItem("role_id");
    const [projectdata, serProjectdata] = useState([]);
    function GetProjectStatusData() {
        let url = `${config.url.FAC_URL}getSubjectFacultyDetails`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" &&
                res?.data?.subj_details?.length > 0) {
                serProjectdata(res?.data?.subj_details);
            } else {
                serProjectdata([]);
            }
        });
    }
    useEffect(() => {
        GetProjectStatusData();

    }, [])


    function HandleBacktoMaker(sno) {
        Swal.fire({
            text: 'Are you sure you want to Back to Maker ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Back!',
            cancelButtonText: 'Cancel',
            backdrop: false,
            confirmButtonColor: '#2e7d32',
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.FAC_URL}sendSubjectDeptData?sno=${sno}`;
                const payload = {
                    isCheckerApproved: true
                }
                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlert2(res?.data?.sdesc);
                        GetProjectStatusData();
                    } else {
                        Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
                    }
                });
            }
        });
    }


    const ActionCell = ({ row }) => {
        const isApproved = row.original.is_checker_approved;

        if (isApproved) {
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                    }}
                >
                    <span
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#e8f5e9",
                            color: "#2e7d32",
                            fontWeight: 600,
                            padding: "4px 12px",
                            borderRadius: "20px",
                            fontSize: "13px",
                        }}
                    >
                        <FaCheckCircle style={{ marginRight: "6px" }} />
                        Approved
                    </span>
                </div>
            );
        }

        const approveStyle = {
            padding: "6px 12px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            color: "white",
            backgroundColor: "#4caf50", // direct green
            boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
        };

        const backStyle = {
            padding: "6px 12px",
            borderRadius: "6px",
            border: "none",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            color: "white",
            backgroundColor: "#f44336", // direct red
            boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
        };

        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    height: "100%",
                }}
            >
                <button
                    type="button"
                    style={approveStyle}
                    onClick={() => handleApprove(row.original.sno)}
                    title="Approve"
                >
                    Approve
                </button>

                <button
                    type="button"
                    style={backStyle}
                    onClick={() => HandleBacktoMaker(row.original.sno)}
                    title="Back to Maker"
                >
                    Back
                </button>
            </div>
        );
    };

    function handleApprove(sno) {
        Swal.fire({
            text: 'Are you sure you want to approve ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Approve!',
            cancelButtonText: 'Cancel',
            backdrop: false,
            confirmButtonColor: '#2e7d32',
        }).then((result) => {
            if (result.isConfirmed) {
                const url = `${config.url.FAC_URL}updateCheckerApprovalDept?sno=${sno}`;
                const payload = {
                    isCheckerApproved: true
                }
                CommonAxiosPost(url, payload).then((res) => {
                    if (res?.data?.scode === "01") {
                        successAlert2(res?.data?.sdesc);
                        GetProjectStatusData();
                    } else {
                        Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
                    }
                });
            }
        });
    }
    const SubjectReportColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,

        },
        {
            id: "dept_name",
            header: "Name of the Department / Subject",
            accessorKey: "dept_name",
            meta: { style: { textAlign: "left" } },
            Footer: "Total",

        },
        {
            id: "designation",
            header: "Name of the Designation (At the time of Appointment)",
            accessorKey: "designation",
            meta: { style: { textAlign: "left" } },

        },


        {
            id: "no_of_san_posts",
            header: "No of sanctioned posts (GO Ms No 95 dt 16-09-2023)",
            accessorKey: "no_of_san_posts",
            Footer: true,
        },
        {
            id: "no_of_reg_fac_working",
            header: "No of regular faculty working",
            accessorKey: "no_of_reg_fac_working",
            Footer: true,
        },
        {
            id: "no_of_contract_fac_working",
            header: "No of contract faculty working",
            accessorKey: "no_of_contract_fac_working",
            Footer: true,
        },
        {
            id: "no_of_guest_fac_working",
            header: "No of Guest faculty working",
            accessorKey: "no_of_guest_fac_working",
            Footer: true,
        },
        {
            id: "no_of_adhoc_fac_working",
            header: "No of Adhoc faculty working",
            accessorKey: "no_of_adhoc_fac_working",
            Footer: true,
        },
        {
            id: "academic_consultant",
            header: "No of Academic Consultants",
            accessorKey: "academic_consultant",
            Footer: true,
        },
        ...(userId === "U-0632_maker"
            ? [{
                id: "rgukt_mentor",
                header: "No of RGUKT Mentors",
                accessorKey: "rgukt_mentor",
                Footer: true,
            }]
            : []),

        {
            id: "no_of_vacancy",
            header: "No of Vacancy",
            cell: ({ row }) =>
                (Number(row.original.no_of_san_posts) || 0) -
                (Number(row.original.no_of_reg_fac_working) || 0),
            Footer: ({ table }) => {
                const total = table.getRowModel().rows.reduce(
                    (sum, row) =>
                        sum +
                        (Number(row.original.no_of_san_posts) || 0) -
                        (Number(row.original.no_of_reg_fac_working) || 0),
                    0
                );
                return <strong>{total}</strong>;
            },
            meta: { style: { textAlign: "right" } },
        },

        ...(ROLEID === "4"
            ? [
                {
                    id: "action",
                    header: "Action",
                    cell: ActionCell,
                },
            ]
            : []),
    ];
    return (
        <>

            <div className="faculty-card">
                <div className='fac-topbar'>

                    <div className='fac-detnew'>
                        <h5 className='mb-0'>Department  Report</h5>
                    </div>

                </div>
                {projectdata?.length > 0 ? (
                    <>
                        <div className="table-responsive">
                            <CommonReactTable
                                data={projectdata}
                                columns={SubjectReportColumns}
                                filename="Department wise Report"
                                headerName="Department wise Report"
                                showFooter={true}
                                showPagination={false}
                                showExcel={true}
                                showPrint={true}
                                excelFileName="Department wise Report"


                            />
                        </div>
                    </>
                ) : (<center className="text-danger h5">**** No Data Found ****</center>
                )}
            </div>

        </>)
}
